import type { IndexFilterOrdering } from '@/components/page-sections/index-section-utils';
import type { CaseResultRecord } from '@/lib/blocks/collection/records';
import type { PaginationInfo } from '@/types/pagination';
import type { PracticeArea } from '@/types/shared';

export interface PaginatedCaseResults {
  data: CaseResultRecord[];
  pinned?: CaseResultRecord[];
  pagination: PaginationInfo;
}

export interface CaseResultIndexFilters {
  practiceAreas?: string[];
  attorneyId?: string;
}

export interface CaseResultIndexProps {
  pinned?: CaseResultRecord[];
  pinnedHeading?: string;
  pinnedDescription?: string;
  backgroundColor?: string | null;
  backgroundFullWidth?: boolean;
  caseResults?: PaginatedCaseResults;
  practiceAreas?: PracticeArea[];
  showFilters?: boolean;
  filterLimit?: number;
  filterOrdering?: IndexFilterOrdering;
  perPage?: number;
  orderBy?: string;
  filters?: CaseResultIndexFilters;
}

export enum CaseResultIndexVariant {
  LIST_LAYOUT = 'list',
  GRID_LAYOUT = 'grid',
  SPLIT_LAYOUT = 'split',
}
